const startRequest = (state: Object) => {
  ++state.agreements.requestsInProgress;
  return state;
};
const finishRequest = (state: Object) => {
  if (state.agreements.requestsInProgress > 0) --state.agreements.requestsInProgress;
  return state;
};

export const setLoading = (state: Object) => () => startRequest(state);

export const onGetAgreementsSuccess = (state: Object) => ({ payload }: Object) => {
  state.error = null;
  state.agreements.list = payload;
  return finishRequest(state);
};

export const onGetSlaSchemaSuccess = (state: Object) => ({ payload }: Object) => {
  state.error = null;
  state.agreements.schema = payload;
  return finishRequest(state);
};

export const onToggleSlaClientModal = (state: Object) => ({ payload }: Object): Object => {
  state.agreements.activeClientModal = payload;
  return state;
};

export const onGetSlaSchemaError = (state: Object) => ({ payload }: Object) => {
  state.error = null;
  return finishRequest(state);
};

export const onPutAgreementsSuccess = (state: Object) => ({ payload }) => {
  return finishRequest(state);
};

export const onPutAgreementsError = (state: Object) => ({ payload }: Object) => {
  state.error = payload;
  return finishRequest(state);
};

export const onGetAgreementsError = (state: Object) => ({ payload }: Object) => {
  state.agreements.list.content = [];
  state.error = payload;
  return finishRequest(state);
};
